import dischargeCurveComponent from './curve.component';
import dischargeTableComponent from './table.component';
import dischargeDataListComponent from './data-list/discharge-data-list.component';
import dischargeModelListComponent from './model-list/model-list.component';

import DischargeCurveFittingService from './fitting.service';
import dischargeDataListCurveFactory from './discharge-data-list-curve.directive';
import dischargeModelListCurveFactory from './model-list-curve.directive';
import ModelCreatorService from './model-creator.service';
import modelFormatterFactory from './model.formatter';

export default angular.module('imomo.discharge', [])
    .component('imomoDischargeCurve', dischargeCurveComponent)
    .component('imomoDischargeTable', dischargeTableComponent)
    .component('imomoDischargeDataList', dischargeDataListComponent)
    .component('imomoDischargeModelList', dischargeModelListComponent)
    .directive('imomoDischargeDataListCurve', dischargeDataListCurveFactory)
    .directive('imomoDischargeModelListCurve', dischargeModelListCurveFactory)
    .service('dischargeCurveFittingService', DischargeCurveFittingService)
    .service('modelCreatorService', ModelCreatorService)
    .filter('dischargeModelFormatter', modelFormatterFactory)
    .name;



/** WEBPACK FOOTER **
 ** ./app/discharge/discharge.module.ts
 **/